import { useState } from 'react';

interface ResettableToggle {
    isShown: boolean;
    reopen: () => void;
    close: () => void;
}

export const useResettableToggle = (): ResettableToggle => {
    const [isShown, setIsShown] = useState(false);

    const reopen = () =>
        setIsShown(previouslyShown => {
            if (!previouslyShown) {
                return true;
            }

            setTimeout(() => setIsShown(true), 0);
            return false;
        });

    const close = () => setIsShown(false);

    return { isShown, reopen, close };
};
